import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=2faefe6b&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=2faefe6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faefe6b",
  null
  
)

export default component.exports